import { AxiosError } from 'axios';
import {
  MutationFunction,
  useMutation,
  UseMutationResult,
  useQueryClient
} from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { Team } from '@utils/api/teams/use-get-teams.tsx';

export const useCreateTeam = (): UseMutationResult<
  Team,
  AxiosError<BaseError>,
  { name: string; description: string },
  unknown
> => {
  const queryClient = useQueryClient();

  const createTeam: MutationFunction<
    Team,
    { name: string; description: string }
  > = async ({ name, description }) => {
    const response = await Axios.post<Team>(POST_URL().createTeam, {
      name,
      description
    });
    return response.data;
  };

  return useMutation<
    Team,
    AxiosError<BaseError>,
    { name: string; description: string }
  >(['createTeam'], createTeam, {
    onSuccess: () => {
      queryClient.invalidateQueries('teams');
    },
    useErrorBoundary: false
  });
};
